import { useEffect } from 'react';
import { useBackLinkStore } from '@/store';

export const usePageBackLink = (onBack: () => void, label: string): void => {
  const setBackLink = useBackLinkStore((s) => s.setBackLink);
  const clearBackLink = useBackLinkStore((s) => s.clearBackLink);

  useEffect(() => {
    setBackLink(onBack, label);
  });

  useEffect(() => () => clearBackLink(), [clearBackLink]);
};

export default usePageBackLink;
